class MixedButton extends Button {
    constructor(oldContainer: JQuery, controller: Controller, mode: string) {
        super(oldContainer.attr("id"), controller, oldContainer, mode);
    }

    initHTML (oldElement) {
        var label = oldElement.text();

        var newHTML = '';

        newHTML += '<div class="button" id="' + this.identifier + '_mixed_' + this.mode + '">';
        newHTML += '    <div class="label">' + label + '</div>';
        newHTML += '    <div class="layer layer1">&nbsp;</div>';
        newHTML += '    <div class="layer layer2 disabled hidden">&nbsp;</div>';
        newHTML += '    <div class="layer step hidden"></div>';
        newHTML += '</div>';

        this.container = $(newHTML);

        oldElement.replaceWith(this.container);
    }

   setEnabled (enabled) {
        this.container.toggleClass("disabled", !enabled);
    }

   isEnabled() {
        return !this.container.hasClass("disabled");
    }

   previewEnabled (enabled) {
        this.container.find(".layer2").toggleClass("disabled", !enabled);
        this.container.find(".layer2").removeClass("hidden");
    }

    protected removePreviewEnabled() {
        this.container.find(".layer2").addClass("hidden");
    }

    setVisible(visible) {
        console.log("TODO: implement setVisible() in mixed buttons");
    }

   previewVisible (visible) {

    }

   removeNextStatePreview () {
        this.container.find(".layer2").addClass("hidden");
    }

   removePreviousStatePreview () {
        // TODO
    }

   /**
     * This function is called for the guidance feature, should be stackable (called multiple times in a row)
     * @param stepIndex the order of the step
     * @param event the event that must be completed
     */
    showTransition (stepIndex, event) {
        var element = this.container.find(".step");

        if(element.text().length > 0) {
            element.text(element.text() + "," + stepIndex);
        } else {
            element.text(stepIndex);
        }

        element.removeClass("hidden");
    }

   /**
     * This function is called for the guidance feature
     */
    hideTransition () {
        this.container.find(".step").addClass("hidden").empty();
    }
}
